<mat-form-field class="multi-select">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipGrid>
    @for (item of chips(); track item) {
    <mat-chip-row (removed)="removeElement(item)">
      {{ item.name }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    }
    <input [placeholder]="placeholder" #filterInput [formControl]="filterControl" [matChipInputFor]="chipGrid" [matAutocomplete]="auto" />
    @if (chips().length) {
    <button matSuffix mat-icon-button (click)="reset()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-chip-grid>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedElement($event)">
    @for (item of filteredOptions | async; track item) {
    <mat-option [value]="item.name">{{ item.name }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
